import { IGrupos } from '../interface';
import { notification } from 'antd';
import { useCallback, useRef, useState } from 'react';

import axios from 'axios';
import GruposReceitasService from '../../../services/http/services/ConfiguracoesReceitas/GruposReceitasService';

export const useGrupo = () => {
    const [grupos, setGrupos] = useState<IGrupos[]>([]);
    const [sistemasGrupos, setSistemasGrupos] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [loadingGrupoModal, setLoadingGrupoModal] = useState(false);

    const signalRef = useRef(axios.CancelToken.source());

    const getGrupos = useCallback(async () => {
        setLoading(true);
        try {
            const data = await GruposReceitasService.getGrupos(signalRef.current.token);
            setGrupos(data);
        } catch (error) {
            if (!axios.isCancel(error)) {
                notification.error({
                    message: 'Erro',
                    description: 'Erro ao carregar grupos!'
                });
            }
        } finally {
            setLoading(false);
        }
    }, []);

    const createGrupo = useCallback(async (nome: string) => {
        setLoadingGrupoModal(true);
        try {
            const novoGrupo = await GruposReceitasService.postGrupos(nome, signalRef.current.token);

            notification.success({
                message: 'Sucesso',
                description: 'Grupo criado com sucesso!',
            });

            await getGrupos();
            return novoGrupo;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível criar o grupo!',
            });
            return null;
        } finally {
            setLoadingGrupoModal(false);
        }
    }, [getGrupos]);

    const updateGrupo = useCallback(async (id: string, nome: string) => {
        setLoadingGrupoModal(true);
        try {
            await GruposReceitasService.updateGrupos(id, nome, signalRef.current.token);

            notification.success({
                message: 'Sucesso',
                description: 'Grupo atualizado!'
            });

            await getGrupos();
            return true;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível atualizar!',
            });
            return false;
        } finally {
            setLoadingGrupoModal(false);
        }
    }, [getGrupos]);

    const updateGruposOrdem = useCallback(async (grupos: IGrupos[]) => {
        setLoadingGrupoModal(true);
        try {
            await GruposReceitasService.updateGruposOrdem(grupos, signalRef.current.token);

            notification.success({
                message: 'Sucesso',
                description: 'Ordem atualizada com suecesso!'
            });

            await getGrupos();
            return true;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível atualizar!',
            });
            return false;
        } finally {
            setLoadingGrupoModal(false);
        }
    }, [getGrupos]);

    const deleteGrupo = useCallback(async (id: string) => {
        try {
            const data = await GruposReceitasService.deleteGrupos(id, signalRef.current.token);

            if (data.message === 'Removido com sucesso') {
                notification.success({
                    message: 'Sucesso',
                    description: 'Grupo apagado!'
                });
                await getGrupos();
            }
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível apagar!'
            });
        }
    }, [getGrupos]);

    const getSistemasGrupos = useCallback(async () => {
        setLoading(true);
        try {
            const data = await GruposReceitasService.getSistemasGrupos(signalRef.current.token);
            setSistemasGrupos(data);
        } catch (error) {
            if (!axios.isCancel(error)) {
                notification.error({
                    message: 'Erro',
                    description: 'Erro ao carregar grupos!'
                });
            }
        } finally {
            setLoading(false);
        }
    }, []);

    const postRepublicarSistemaGrupos = useCallback(async (sistema: string) => {
        setLoadingGrupoModal(true);
        try {
            const data = await GruposReceitasService.postRepublicarSistemasGrupos(sistema, signalRef.current.token);

            if (sistema === 'todos') {
                notification.success({
                    message: 'Sucesso',
                    description: 'Republicação iniciada para todos os sistemas!',
                });
            } else {

                notification.success({
                    message: 'Sucesso',
                    description: data.message,
                });
            }

            await getGrupos();

            return true;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível atualizar!',
            });
            return false;
        } finally {
            setLoadingGrupoModal(false);
        }
    }, [getGrupos]);

    return {
        grupos,
        loading,
        sistemasGrupos,
        loadingGrupoModal,
        getGrupos,
        createGrupo,
        updateGrupo,
        deleteGrupo,
        updateGruposOrdem,
        getSistemasGrupos,
        postRepublicarSistemaGrupos,
    };
};
